import { createActionCreator } from '@reduxify/utils';

import { SET_PAYMENT_GATEWAY } from './constants';
import { IPaymentState } from './types';

export const setPaymentGateway =
  createActionCreator<IPaymentState['gateway']>(SET_PAYMENT_GATEWAY);
